import { SortButton } from '@infl-ts/ui-advocate-components';
import { keysWithMap } from '@infl-ts/util-io-ts';
import { jsx as _jsx } from "react/jsx-runtime";
export var ChallengeSortType = keysWithMap({
  Recommended: 'Recommended',
  Newest: 'Newest',
  'Most points': 'MostPoints'
});

var ChallengeSort = function ChallengeSort(_ref) {
  var challengeSortBy = _ref.challengeSortBy,
      changeChallengeSortBy = _ref.changeChallengeSortBy;
  return /*#__PURE__*/_jsx(SortButton, {
    entity: "Challenges",
    sortBy: challengeSortBy,
    handleChangeSort: changeChallengeSortBy,
    sortOptions: [ChallengeSortType.map.Recommended, ChallengeSortType.map.Newest, ChallengeSortType.map.MostPoints],
    "data-element": "SortButton",
    "data-component": "ChallengeSort",
    "data-source-file": "challenge-sort.tsx"
  });
};

export default ChallengeSort;